<template lang="pug">
.gallery.relative
  .relative.scroll-hidden
    .images(ref="images" @mousedown.prevent="mouseDown" @mouseup.prevent="mouseUp" @mousemove.prevent="mouseMove" @mouseleave="mouseLeave" @touchstart="mouseDown" @touchend="mouseUp" @touchmove="mouseMove" @touchleave="mouseLeave")
      .image-container.relative(v-for="(image, index) in images" :class="{'transition-images': !isMoving && showAnimation}" :style="`left:${isMoving ? `${positionGallery}px` : `${positionGalleryPercent}%`}`")
        picture(v-if="index >= 0")
          source(:srcset="`${imagePath}/${folder}${ subfolder ? `/${subfolder}` : ''}/${image.replace('.jpg', '.avif')}`" type="image/avif")
          source(:srcset="`${imagePath}/${folder}${ subfolder ? `/${subfolder}` : ''}/${image.replace('.jpg', '.webp')}`" type="image/webp")
          source(:srcset="`${imagePath}/${folder}${ subfolder ? `/${subfolder}` : ''}/${image}`" type="image/jpeg")
          img.image(:class="classImage" :src="`${imagePath}/${folder}${ subfolder ? `/${subfolder}` : ''}/${image}`" :alt="alt")
    .left-arrow(v-if="currentImage !== 0")
      a
        img.left-arrow-image(:src="`${imagePath}/others/arrow.svg`" alt="back" @click="previusImage")
    .right-arrow(v-if="currentImage < images.length - 1")
      a
        img.right-arrow-image(:src="`${imagePath}/others/arrow.svg`" alt="next" @click="nextImage")
    // .zoom-container(v-if="!hideZoom")
      a
        img.zoom-image(:src="`${imagePath}/others/expand.svg`" alt="expand" @click="zoomImage")
  .circles-container
    .circles
      .circle.bg-soft(v-for="(n, index) in images.length" :class="{'circle-active': index === currentImage}")
</template>

<script>
export default {
  name: 'Gallery',

  props: {
    images: Array,
    folder: String,
    subfolder: String,
    classImage: String,
    classContainer: String,
    imagePath: String,
    alt: String,
    styleContainer: String,
    hideZoom: Boolean,
    current: Number,
    steps: Boolean
  },

  data () {
    return {
      currentImage: 0,
      isMoving: false,
      showAnimation: true,
      positionInicial: 0,
      positionFinal: 0,
      positionXi: 0,
      positionXf: 0,
      positionYi: 0,
      positionYf: 0,
      positionGallery: 0,
      positionGalleryPercent: 0,
      maxSlide: 0,
      quantityImages: 0,
      topArrow: 0
    }
  },

  mounted () {
    if (this.current) this.moveImage(this.current, true)
  },

  methods: {
    zoomImage () {
      this.$store.commit('showZoom', { show: true, images: this.images, folder: this.folder, subfolder: this.subfolder, current: this.currentImage })
    },

    nextImage () {
      if (this.currentImage < this.images.length - 1) ++this.currentImage
      this.moveImage()
    },

    previusImage () {
      if (this.currentImage > 0) --this.currentImage
      this.moveImage()
    },

    moveImage (index, hideAnimation) {
      if (index >= 0) this.currentImage = index
      if (hideAnimation) this.showAnimation = false
      const currentImage = this.currentImage
      const images = this.$refs.images
      const width = images.clientWidth
      const left = (width * currentImage)
      this.positionGallery = -left
      this.positionGalleryPercent = -(currentImage * 100)

      if (hideAnimation) setTimeout(() => { this.showAnimation = true }, 0)
      this.$emit('changeImage', currentImage)
    },

    mouseDown () {
      const event = window.event
      const newEvent = event.touches && event.touches[0] ? event.touches[0] : window.event
      this.positionXi = newEvent.clientX
      this.positionYi = newEvent.clientY
      this.positionInicial = this.positionXi - this.positionGallery
      this.isMoving = true
    },

    mouseUp () {
      this.moveIfSlide()
    },

    mouseLeave () {
      if (this.isMoving) {
        this.moveIfSlide()
      }
    },

    moveIfSlide () {
      this.isMoving = false

      const moveNext = (this.positionXf - this.positionXi) < 0
      const movePrevius = (this.positionXf - this.positionXi) > 0
      const moveX = Math.abs(this.positionXf - this.positionXi) > 30
      const moveY = Math.abs(this.positionYf - this.positionYi) > 100

      if (!moveX || moveY) {
        this.moveImage()
        return
      }

      if (moveNext) {
        this.nextImage()
      } else if (movePrevius) {
        this.previusImage()
      }
    },

    mouseMove () {
      if (this.isMoving) {
        const event = window.event
        const newEvent = event.touches && event.touches[0] ? event.touches[0] : window.event
        this.positionXf = newEvent.clientX
        this.positionYf = newEvent.clientY
        this.positionFinal = this.positionXf
        this.positionGallery = this.positionFinal - this.positionInicial
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/stylus/functions.styl'
@import '~@/stylus/variables.styl'

.images, .circles
  display flex
  flex-wrap nowrap
  position relative
  z-index 5

.images
  overflow hidden

.transition-images
  transition left 0.5s ease

.image-container
  flex 1 0 auto
  width 100%

.image
  width 100%

.circles
  display inline-flex
  align-items center

.circle
  height .5rem
  width .5rem
  margin 0 .2em
  background-color rgb(250, 250, 250, 0.9)

.circle-active
  background-color black

.right-arrow, .left-arrow
  position absolute
  right .8em
  height 100%
  display none
  align-items center
  top 0
  z-index 6

.left-arrow
  left .8em
  right auto

.left-arrow-image, .right-arrow-image
  cursor pointer
  opacity .4

.left-arrow-image:hover, .right-arrow-image:hover
  opacity .8

.left-arrow-image
  height 2.4em
  transform rotateZ(180deg)

.right-arrow-image
  height 2.4em

.zoom-container
  position absolute
  bottom 1em
  right 1em
  z-index 7
  opacity .3
  cursor pointer

.zoom-container:hover
  opacity .7

.zoom-image
  height 1.9em

.circles-container
  position absolute
  bottom 1rem
  left 1rem

//Laptop
@media(min-width: 941px)
  .right-arrow, .left-arrow
    display flex
</style>



// WEBPACK FOOTER //
// src/components/ecommerce/Gallery.vue